import { CircularProgress, Stack } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useBootstrapStatus } from '../api/queries';
import { TOKEN_STORAGE_KEY } from './config';

/**
 * What "/" should resolve to:
 *   - Already signed in → /home
 *   - Bootstrap path is open (no admin yet) → /setup
 *   - Otherwise → /login
 *
 * The bootstrap-status check is a single GET; while it's in flight we
 * render a small spinner so the user never sees a flash of the wrong
 * page.
 */
export function RootRedirect() {
  // Hooks must run unconditionally — call useBootstrapStatus first,
  // then branch on the token afterwards. The query is cached + cheap,
  // and we ignore its result on the signed-in path.
  const status = useBootstrapStatus();
  const hasToken = typeof window !== 'undefined'
    && !!window.sessionStorage.getItem(TOKEN_STORAGE_KEY);

  if (hasToken) return <Navigate to="/home" replace />;

  if (status.isLoading) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ minHeight: '100vh' }}>
        <CircularProgress />
      </Stack>
    );
  }
  if (status.data?.available) return <Navigate to="/setup" replace />;
  return <Navigate to="/login" replace />;
}
